import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import contactImage from '../assets/img/contact-img.svg';

const Contact = () => {
    const handleSubmit = async (e) => {
        e.preventDefault();
    }

    return (
        <section className='contact' id='connect'>
            <Container>
                <Row className='align-item-center'>
                    {/* Image that are on left */}
                    <Col md={6}>
                        <img src={contactImage} alt="Contact" />
                    </Col>
                    {/* content on right */}
                    <Col md={6}>
                        <h2>Get In Touch</h2>
                        {/* Form Submit */}
                        <form onSubmit={handleSubmit} >
                            <Row className='animate-contact'>
                                <Col sm={6} className='px-1'>
                                    <input type="text" placeholder='Enter Your First Name' />
                                </Col>
                                <Col sm={6} className='px-1'>
                                    <input type="text" placeholder='Enter Your Last Name' />
                                </Col>
                                <Col sm={6} className='px-1'>
                                    <input type="email" placeholder='Enter Your Email' />
                                </Col>
                                <Col sm={6} className='px-1'>
                                    <input type="tel" placeholder='Enter Your Phone Number' />
                                </Col>
                                <Col>
                                    <textarea placeholder='Enter Your Message'></textarea>
                                    <button type="submit"><span>Send</span></button>
                                </Col>
                            </Row>
                        </form>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Contact;